export const PAGE_SIZE = 10
export const LOOKUP_LIMIT = 1000
export const DEFAULT_ORDER = '-changedStatusAt'

export const gatewayBlocksUrl = (clientId: string) =>
  `/gateway/by-client/${clientId}/blocks`

export const blockGatewayUrl = '/gateway/block'

export const allGatewaysUrl = '/gateway'
export const ALL_GATEWAYS_PAGE_SIZE = 10
export const ALL_GATEWAYS_ORDER = '-id'

export const STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Blocked', value: 'blocked' },
]

export const PM_TAB_LIST = 'list'
export const PM_TAB_HISTORY = 'history'
export const PM_TAB_DEFAULT = PM_TAB_LIST

// Kept apart from the gateway filters so that switching tabs neither drops the
// list filters nor gets wiped by "Reset all".
export const FILTER_CONFIG_PM_TAB = {
  pmTab: { type: 'string' as const, default: PM_TAB_DEFAULT },
}

export const FILTER_CONFIG_GATEWAYS = {
  gatewayId: { type: 'string' as const },
  internalName: { type: 'string' as const },
  processingProvider: { type: 'string' as const },
  paymentMethodType: { type: 'string' as const },
  status: { type: 'string' as const },
  sorterField: {
    type: 'string' as const,
    default: DEFAULT_ORDER,
    pagination: true,
  },
  page: { type: 'string' as const, default: '1', pagination: true },
  pageSize: {
    type: 'string' as const,
    default: String(PAGE_SIZE),
    pagination: true,
  },
}

export const HISTORY_PAGE_SIZE = 10
export const DETAILS_PAGE_SIZE = 10
export const HISTORY_DEFAULT_ORDER = '-createdAt'

export const EMPTY_VALUE = '—'

export const gatewayHistoryUrl = (clientId: string) =>
  `${gatewayBlocksUrl(clientId)}/history`

export const gatewayHistoryDetailsUrl = (clientId: string, gatewayId: number) =>
  `${gatewayHistoryUrl(clientId)}/${gatewayId}`

export const FILTER_CONFIG_HISTORY = {
  hGatewayId: { type: 'string' as const },
  hInternalName: { type: 'string' as const },
  hStatus: { type: 'string' as const },
  hSorterField: {
    type: 'string' as const,
    default: HISTORY_DEFAULT_ORDER,
    pagination: true,
  },
  hPage: { type: 'string' as const, default: '1', pagination: true },
  hPageSize: {
    type: 'string' as const,
    default: String(HISTORY_PAGE_SIZE),
    pagination: true,
  },
}
